import { authSessionSchema } from '@/lib/api/schemas'
import type { AuthSession } from '@/types/api'

/**
 * `vectraclip-jwt` — única chave de localStorage permitida pelo PRD §9.
 *
 * Mantemos o nome legado da v1 (era só uma string com o token) e mudamos o
 * VALOR para JSON serializado de `AuthSession` completa. O `defaultGetToken`
 * em `src/lib/api/client.ts` faz o reading com fallback, então sessões
 * antigas em storage não quebram (vão expirar e cair pelo fluxo normal).
 */
const STORAGE_KEY = 'vectraclip-jwt'

export function readSession(): AuthSession | null {
  if (typeof window === 'undefined') return null
  const raw = window.localStorage.getItem(STORAGE_KEY)
  if (!raw) return null

  let json: unknown
  try {
    json = JSON.parse(raw)
  } catch {
    // String legada da v1 (só access token) — limpa pra forçar re-login.
    window.localStorage.removeItem(STORAGE_KEY)
    return null
  }

  const parsed = authSessionSchema.safeParse(json)
  if (!parsed.success) {
    window.localStorage.removeItem(STORAGE_KEY)
    return null
  }
  return parsed.data
}

export function writeSession(session: AuthSession): void {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session))
}

export function clearSession(): void {
  if (typeof window === 'undefined') return
  window.localStorage.removeItem(STORAGE_KEY)
}
